import { Type } from "js-yaml";
import { CUSTOM_TAGS } from "../constants.js";
import { fromDataSource } from "../utils/fromDataSource.js";
const represent = (parsedDataSource) => {
  if (!(parsedDataSource instanceof ParsedDataSource && typeof parsedDataSource.sources === "object" && Object.keys(parsedDataSource.sources).length > 0)) {
    throw new Error("Invalid data source representation");
  }
  const rawDataSource = {};
  Object.entries(parsedDataSource.sources).forEach(([, definition]) => {
    const { key, source, filters, sortBy, limit, offset } = definition;
    rawDataSource[key] = {
      source
    };
    if (filters && Array.isArray(filters) && filters.length > 0) {
      rawDataSource[key].filters = filters;
    }
    if (sortBy && typeof sortBy === "string") {
      rawDataSource[key].sortBy = sortBy;
    }
    if (limit !== void 0) {
      rawDataSource[key].limit = limit;
    }
    if (offset !== void 0) {
      rawDataSource[key].offset = offset;
    }
  });
  return rawDataSource;
};
const flattenDataSources = (data) => {
  const sources = {};
  for (const [key, value] of Object.entries(data)) {
    if (typeof value.source === "string") {
      sources[key] = {
        key,
        source: value.source,
        filters: value.filters || [],
        sortBy: value.sortBy,
        limit: value.limit,
        offset: value.offset,
        fromDataSource(dataset) {
          return fromDataSource({
            filters: this.filters,
            sortBy: this.sortBy,
            limit: this.limit,
            offset: this.offset
          }, dataset);
        }
      };
    }
  }
  return sources;
};
class ParsedDataSource {
  sources;
  constructor(data = {}) {
    if (typeof data !== "object" || data === null || Object.keys(data).length === 0) {
      throw new Error("Invalid data source key or data structure.");
    }
    this.sources = flattenDataSources(data);
  }
}
const DataSourceTag = new Type(CUSTOM_TAGS.DATA_SOURCE, {
  kind: "mapping",
  // kind: 'scalar',
  multi: true,
  resolve: (data) => typeof data === "object" && data !== null,
  construct: (data) => new ParsedDataSource(
    typeof data === "string" ? { [data]: { source: data } } : data
  ),
  instanceOf: ParsedDataSource,
  represent,
  representName: () => "!data_source"
});
export {
  DataSourceTag,
  ParsedDataSource
};
